import http from './client';
import { withParams } from './utils';

/**
 * Tag OpenAPI: Blog
 * Noticias (`/blog-posts`), sus imágenes y categorías (`/blog-post-categories`).
 * Crear/editar/borrar requiere rol admin, executive, director o administrative.
 */

export const blogPostsApi = {
  list: (params = {}) => http.get('/blog-posts', withParams(params)),
  get: (id) => http.get(`/blog-posts/${id}`),
  create: (body) => http.post('/blog-posts', body),
  update: (id, body) => http.put(`/blog-posts/${id}`, body),
  remove: (id) => http.delete(`/blog-posts/${id}`),
};

export const blogPostImagesApi = {
  list: (postId) => http.get(`/blog-posts/${postId}/images`),
  /**
   * Sube varias imágenes en un solo request (campo multipart `images` repetido).
   * @param {string} postId
   * @param {File[]} files
   */
  upload: (postId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    return http.post(`/blog-posts/${postId}/images`, formData);
  },
  remove: (postId, imageId) => http.delete(`/blog-posts/${postId}/images/${imageId}`),
  setCover: (postId, imageId) => http.put(`/blog-posts/${postId}/images/${imageId}/cover`),
  reorder: (postId, imageIds) => http.post(`/blog-posts/${postId}/images/reorder`, { image_ids: imageIds }),
};

export const blogCategoriesApi = {
  list: (params = {}) => http.get('/blog-post-categories', withParams(params)),
  get: (id) => http.get(`/blog-post-categories/${id}`),
  create: (body) => http.post('/blog-post-categories', body),
  update: (id, body) => http.put(`/blog-post-categories/${id}`, body),
  remove: (id) => http.delete(`/blog-post-categories/${id}`),
  toggleActive: (id) => http.patch(`/blog-post-categories/${id}/toggle-active`),
};
